module.exports = "pegasus/assets/email1-google.png";